import Vue from "vue";
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

export const i18n = new VueI18n({
        locale: 'en',
        fallbackLocale: 'de',
        messages: {

            en: {
                menu: {
                    dashboard: 'Dashboard',
                    generator: 'Generator',
                    account: 'Account',
                    language: 'Language',
                },

                dashboard: {
                    title: 'Publications Management Tool',
                    desc: 'Manage your publications projects',
                },
                account: {
                    title: 'Account',
                    desc: 'Here you can see all your account details.',
                },
                generator: {
                    title: 'Generator',
                    desc: 'Here you can generate HTML code according to your needs. Please let the filter fields empty, in case no filter should be applied, ',
                    publicationsview: {
                        short: 'Generate HTML',
                        copystring: 'Copy String to Clipboard',
                        author: {
                            field: 'Author',
                            firstName: 'First Name',
                            lastName: 'Last Name',
                        },
                        type: {
                            field: 'Type'
                        },
                        tag: {
                            field: 'Tags'
                        },
                        sorting: {
                            field: 'Sorting'
                        },
                        select: {
                            field: 'Show Select Boxes'
                        },
                        lastupdate: {
                            field: 'Show Last Update'
                        },
                        baseurl: {
                            field: 'Base URL'
                        },
                        pubelementId: {
                            field: 'Publication-Element ID'
                        },
                    },
                    pubentry: {
                        short: 'Generate HTML',
                        pubentry: {
                            field: 'Pub Entries'
                        },
                        lineHeight: {
                            field: 'Line Height'
                        },
                        paddingLeft: {
                            field: 'Padding Left'
                        },
                        pubelementId: {
                            field: 'Publication-Element ID'
                        }

                    }
                },

                //UserLogin
                user: {
                    profile: {
                        id: 'ID',
                        username: 'Username',
                        details: 'Details',
                        fullName: 'Name',
                        email: 'E-Mail',
                        role: 'Role',
                        admin: 'Admin',
                        whitelisted: 'Whitelisted',
                    },
                    login: {
                        short: 'Login',
                        welcome: 'Welcome',
                        title: 'User Login',
                        desc: 'You will be redirected to GitLab!',
                    },
                    logout: {
                        short: 'Logout',
                        title: 'Logout successful',
                        desc: 'You have successfully logged out. Back to'
                    },
                    nonWhitelisted: {
                        desc: 'You have no permission to create or update projects. Please contact an admin!'
                    }
                },
                author: {
                    id: 'ID',
                    firstName: 'First Name',
                    lastName: 'Last Name'
                },

                project: {
                    add: {
                        short: 'Add Project',
                        title: 'Add Project'
                    },
                    remove: {
                        short: 'Remove',
                        title: 'Remove Project',
                        desc: 'Are you sure you want to remove the project? This operation cannot be undone!',
                    },
                    edit: {
                        short: 'Edit',
                        title: 'Edit Project',
                    },
                    whitelist: {
                        short: 'Whitelist',
                        title: 'Whitelist for ',
                        author: {
                            add: {
                                title: 'Add Author to Whitelist',
                                firstName: {
                                    title: 'First Name',
                                    error: 'Missing or wrong First Name',
                                },
                                lastName: {
                                    title: 'Last Name',
                                    error: 'Missing or wrong Last Name',
                                },
                            },
                            remove: {
                                title: 'Remove Author from Whitelist'
                            },
                            drop: {
                                title: 'Drop Whitelist',
                                desc: 'Are you sure you want to drop the whitelist? All authors are being removed!'
                            },
                            importWhitelist: {
                                title: 'Import Whitelist from .json File',
                                desc: 'Please upload a whitelist as JSON'
                            },
                            exportWhitelist: {
                                title: 'Export Whitelist as .json File'
                            },
                        },
                        noAuthorsPresent: 'Currently, there are no authors in the whitelist.'
                    },
                    data: {
                        alias: {
                            title: 'Alias',
                            error: 'Missing or wrong Alias'
                        },
                        zotero: {
                            group: {
                                title: 'Zotero Group Or User ID',
                                error: 'Missing or wrong Zotero Group or User ID!',
                            },
                            prefix: {
                                title: 'Zotero Group or User',
                                error: 'Missing or wrong Group Or User FLag!',
                                group: 'Group',
                                user: 'User',
                            },
                            apiKey: {
                                title: 'Zotero API Key',
                                error: 'Missing or wrong Zotero API Key!',
                            },
                            collectionId: {
                                title: 'Zotero Collection ID',
                                error: 'Missing or wrong Zotero Collection ID!',
                            },
                            maintainers: {
                                title: 'Maintainers',
                                error: 'The project requires at least one maintainer!'
                            }
                        }
                    },
                    migration: {
                        short: 'Migration',
                        title: 'Migration',
                        jobHistory: {
                            id: 'ID',
                            started: 'Start',
                            finished: 'Finished',
                            runtime: 'Runtime',
                            internalName: 'Internal Name',
                            description: 'Description',
                            dataMapJson: 'Data Map JSON',
                            comment: 'Comment',
                        },
                        trigger: {
                            short: 'Trigger Migration',
                            title: 'Trigger Migration now'
                        },
                        logs: {
                            short: 'Job Logs',
                            title: 'Logs for Job',
                            id: 'ID',
                            datetime: 'Timestamp',
                            loglevel: 'Log Level',
                            text: 'Message',
                        }
                    }
                },

                close: 'close',
                cancel: 'Cancel',
                confirm: 'Confirm',

                pageNotFoundTitle: '404 - Not found.',
                pageNotFoundDesc: 'The requested page can not be found.',

                admin: {
                    clients: {
                        title: 'Wimpub Admin Page',
                        desc: 'Here you can edit wimpub users, set whitelists and assign admin rights!',
                        switchWhitelist: {
                            short: 'Switch Whitelisted'
                        },
                        switchAdmin: {
                            short: 'Switch Admin'
                        },
                        deleteClient: {
                            short: 'Remove Client'
                        }
                    },
                    projects: {
                        title: 'Projects',
                        desc: 'Here you can edit all projects!',
                    }
                },

                permission_denied: {
                    title: 'Permission denied!',
                    desc: 'Sorry, but it seems you have no rights to access the publications tool. Please contact an admin!'
                }

            },
            de: {
                menu: {
                    dashboard: 'Dashboard',
                    generator: 'Generator',
                    account: 'Account',
                    language: 'Sprache',
                },

                dashboard: {
                    title: 'Publikations Tool',
                    desc: 'Verwalten Sie Ihre Publikationsprojekte',
                },
                account: {
                    title: 'Account',
                    desc: 'Hier können Sie Ihre Account Details einsehen.',
                },
                generator: {
                    title: 'Generator',
                    desc: 'Hier können Sie die das Publikationstool anhand der Parameter modifizieren. Falls nicht nach einem Feld gefiltert werden soll, lassen Sie dieses Felder bitte leer.',
                    publicationsview: {
                        short: 'Generate HTML',
                        copystring: 'In die Zwischenablage kopieren',
                        author: {
                            field: 'Autor',
                            firstName: 'Vorname',
                            lastName: 'Nachname',
                        },
                        type: {
                            field: 'Typ'
                        },
                        tag: {
                            field: 'Tags'
                        },
                        sorting: {
                            field: 'Sortierung'
                        },
                        select: {
                            field: 'Select Boxen anzeigen'
                        },
                        lastupdate: {
                            field: 'Letztes Update anzeigen'
                        },
                        baseurl: {
                            field: 'Base URL'
                        },
                        pubelementId: {
                            field: 'Publication-Element ID'
                        },
                    },
                    pubentry: {
                        short: 'Generiere HTML',
                        pubentry: {
                            field: 'Pub Entries'
                        },
                        lineHeight: {
                            field: 'Line Height'
                        },
                        paddingLeft: {
                            field: 'Padding Left'
                        },
                        pubelementId: {
                            field: 'Publication-Element ID'
                        }

                    }
                },
                //UserLogin
                user: {
                    profile: {
                        id: 'ID',
                        username: 'Username',
                        details: 'Details',
                        fullName: 'Name',
                        email: 'E-Mail',
                        role: 'Rolle',
                        admin: 'Admin',
                        whitelisted: 'Whitelisted',
                    },
                    login: {
                        short: 'Login',
                        title: 'User Login',
                        desc: 'Sie werden auf GitLab weitergeleitet!',
                    },
                    logout: {
                        short: 'Logout',
                        title: 'Logout erfolgreich',
                        desc: 'Sie haben sich erfolgreich ausgeloggt!'
                    },
                    nonWhitelisted: {
                        desc: 'Sie sind noch nicht zur Nutzung freigeschaltet. Bitte wenden Sie sich an einen Admin!'
                    }
                },

                author: {
                    id: 'ID',
                    firstName: 'Vorname',
                    lastName: 'Nachname'
                },

                project: {
                    add: {
                        short: 'Neues Projekt',
                        title: 'Neues Projekt anlegen'
                    },
                    remove: {
                        short: 'Löschen',
                        title: 'Project löschen',
                        desc: 'Sind Sie sicher? Gelöschte Projekte können nicht wiederhergestellt werden!',
                    },
                    edit: {
                        short: 'Bearbeiten',
                        title: 'Projekt bearbeiten',
                    },
                    whitelist: {
                        short: 'Whitelist',
                        title: 'Whitelist für ',
                        author: {
                            add: {
                                title: 'Autor zur Whitelist hinzufügen',
                                firstName: {
                                    title: 'Vorname',
                                    error: 'Fehlende oder falsche Eingabe',
                                },
                                lastName: {
                                    title: 'Nachname',
                                    error: 'Fehlende oder falsche Eingabe',
                                },
                            },
                            remove: {
                                title: 'Autor aus der Whitelist löschen'
                            },
                            drop: {
                                title: 'Whitelist löschen',
                                desc: 'Sind Sie sicher? Alle Autoren werden aus der Whitelist entfernt!'
                            },
                            importWhitelist: {
                                title: 'Importiere Whitelist aus .json File',
                                desc: 'Bitte laden Sie eine entsprechend formatierte Whitelist JSON Datei hoch'
                            },
                            exportWhitelist: {
                                title: 'Exportiere Whitelist als .json Datei'
                            },
                        },
                        noAuthorsPresent: 'Aktuell existieren keine Autoren in der Whitelist.'
                    },
                    data: {
                        alias: {
                            title: 'Alias',
                            error: 'Fehlende oder falsche Eingabe'
                        },
                        zotero: {
                            group: {
                                title: 'Zotero Gruppen oder Nutzer ID',
                                error: 'Fehlende oder falsche Eingabe',
                            },
                            prefix: {
                                title: 'Zotero Gruppe oder Nutzer',
                                error: 'Fehlende oder falsche Eingabe',
                                group: 'Gruppe',
                                user: 'Nutzer',
                            },
                            apiKey: {
                                title: 'Zotero API Key',
                                error: 'Fehlende oder falsche Eingabe',
                            },
                            collectionId: {
                                title: 'Zotero Collection ID',
                                error: 'Fehlende oder falsche Eingabe',
                            }
                        },
                        maintainers: {
                            title: 'Maintainer',
                            error: 'Wählen Sie mind. einen Maintainer aus!'
                        }
                    },
                    migration: {
                        short: 'Migration',
                        title: 'Migration',
                        jobHistory: {
                            id: 'ID',
                            started: 'Start',
                            finished: 'Beendet',
                            runtime: 'Laufzeit',
                            internalName: 'Int. Name',
                            description: 'Beschreibung',
                            dataMapJson: 'Data Map JSON',
                            comment: 'Kommentar',
                        },
                        trigger: {
                            short: 'Trigger Migration',
                            title: 'Trigger Migration jetzt'
                        },
                        logs: {
                            short: 'Job Logs',
                            title: 'Logs für Job',
                            id: 'ID',
                            datetime: 'Zeitstempel',
                            loglevel: 'Log Level',
                            text: 'Nachricht',
                        }
                    }
                },


                close: 'Schließen',
                cancel: 'Abbrechen',
                confirm: 'Bestätigen',

                pageNotFoundTitle: '404 - Not found.',
                pageNotFoundDesc: 'Die angeforderte Seite wurde nicht gefunden!',

                admin: {
                    clients: {
                        title: 'Wimpub Admin Seite',
                        desc: 'Hier können Sie Nutzer des wimpub-tools editieren, whitelisten und Adminrechte zuweisen.',
                        switchWhitelist: {
                            short: 'Switch Whitelisted'
                        },
                        switchAdmin: {
                            short: 'Switch Admin'
                        },
                        deleteClient: {
                            short: 'Nutzer löschen'
                        }
                    },
                    projects: {
                        title: 'Projekte',
                        desc: 'Hier können Sie alle Projekte editieren.',
                    }
                },
                permission_denied: {
                    title: 'Zugriff verweigert!',
                    desc: 'Entschuldigung, aber sieht danach aus, als ob Sie keine Zugriffsrechte auf das Publikationstool besitzen. Bitte wenden Sie sich an einen Admin!'
            }
            }
        }

    })
;